// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__hO7dr","label":"Labeled_label__2a1pv","divider":"Labeled_divider__2-PXR"};